// platform
import React from 'react';

export const Icon = ({ cssName }: { cssName: string }): JSX.Element => {
    const iconCss = 'icon-glyph ' + cssName;
    return <span className={iconCss}></span>;
};

export const IconEdit = (): JSX.Element => {
    return <Icon cssName="icon-edit" />;
};

export const IconAdd = (): JSX.Element => {
    return <Icon cssName="icon-add" />;
};

export const IconRemove = (): JSX.Element => {
    return <Icon cssName="icon-remove" />;
};

export const IconExcel = (): JSX.Element => {
    return <Icon cssName="icon-pdf" />;
};

export const IconEmptySquare = ({ size = 16, color = '#BBBBBB' }: { size?: number; color?: string }): JSX.Element => {
    return (
        <svg
            width={size}
            height={size}
            viewBox={`0 0 ${size} ${size}`}
            style={{ flexShrink: 0 }}
        >
            <rect
                x="2"
                y="2"
                width={size - 4}
                height={size - 4}
                rx="2"
                ry="2"
                fill="none"
                stroke={color}
                strokeWidth="2"
            />
        </svg>
    );
};
